import { Controller, UseControllerProps } from "react-hook-form";
import type { FieldValues } from "react-hook-form/dist/types/fields";
import {
  CurrencyInput,
  CurrencyInputProps,
} from "../../../components/core/CurrencyInput/CurrencyInput";

export type FormCurrencyInputProps<T extends FieldValues = FieldValues> =
  UseControllerProps<T> & CurrencyInputProps;

export const FormCurrencyInput = <T extends FieldValues = FieldValues>(
  props: FormCurrencyInputProps<T>
) => {
  const { name, control, rules, onChange, ...restProps } = props;

  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      data-testid={name}
      render={({
        field: { onChange: onChangeHF, ref, ...restHFProps },
        fieldState: { error },
      }) => (
        <CurrencyInput
          {...restHFProps}
          {...restProps}
          getInputRef={ref}
          error={error as any}
          onValueChange={(values) => {
            onChangeHF(values.floatValue ?? values.value);
            onChange?.(values.floatValue ?? (values.value as any));
          }}
        />
      )}
    />
  );
};
